module.exports = __webpack_public_path__ + "src/images/chai-logo.f6108efd045ebcd489345bc22964bb86.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chai-logo.png
// module id = 98
// module chunks = 0